import React from 'react';

import cn from 'clsx';

import { ArticleHeading2 } from '@cian/ui-kit';
import { EElementCategory, IField, IStaticElement, TElement } from '../../types/calculator';
import { fieldsMapper, staticMapper } from '../../utils';
import { WithComputedField } from '../BaseField';
import { FieldLayout } from '../FieldLayout';
import { StaticElementLayout } from '../StaticElementLayout';

import styles from './styles.css';

export interface IContentProps {
  elements: TElement[];
}

export const Content: React.FC<IContentProps> = ({ elements }: IContentProps): (React.JSX.Element | null)[] => {
  return elements.map((el, index) => {
    let Field: React.FC<IField>;
    let StaticElement: React.FC<IStaticElement>;

    switch (el.category) {
      case EElementCategory.Field: {
        Field = fieldsMapper(el);

        return (
          <FieldLayout key={el.name + index} offset={el.offset} testId={`${el.name}-field`}>
            <WithComputedField field={el}>
              {field => {
                return (
                  <div className={cn(styles['field-wrapper'], { [styles['hidden']]: field.hidden })}>
                    <Field key={field.name} {...field} />
                  </div>
                );
              }}
            </WithComputedField>
          </FieldLayout>
        );
      }

      case EElementCategory.Group: {
        return (
          <div key={el.category + index}>
            {el.label && <ArticleHeading2>{el.label}</ArticleHeading2>}
            <Content elements={el.elements} />
          </div>
        );
      }

      case EElementCategory.Static: {
        StaticElement = staticMapper(el);

        return (
          <StaticElementLayout key={el.type + index} offset={el.offset} testId={`${el.type}-static`}>
            <StaticElement key={el.category + index} {...el} />
          </StaticElementLayout>
        );
      }
    }
  });
};
